import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export default function Copyright(props) {
  return (
    <Typography variant='body2' color='text.secondary' align='center' {...props}>
      {'Copyright © '}
      <Link color='inherit' href='http://txscd.com'>
        Texas School and City Data Engine
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
      <br />
      powered by <b>pipe | delimited llc</b>
    </Typography>
  );
}
